import script from "./warning-popup.vue?vue&type=script&setup=true&lang=ts"
export * from "./warning-popup.vue?vue&type=script&setup=true&lang=ts"

import "./warning-popup.vue?vue&type=style&index=0&id=df4306a4&scoped=true&lang=less"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-df4306a4"]])

export default __exports__